import classNames from "classnames";
import { ThumbnailContent } from "../../components/Content/ThumbnailContent.tsx";
import { IMAGE_RESOURCE_TYPE } from "../Board/constants.ts";
import type { BrandLogo } from "../types.ts";

export const BrandLogoItem = ({
  brand,
  className,
}: {
  brand: BrandLogo;
  className?: string;
}) => (
  <div
    className={classNames(
      "aspect-square rounded-200 overflow-hidden border-025 p-200 bg-input-surface-rest",
      className,
    )}
  >
    <ThumbnailContent
      resourceType={IMAGE_RESOURCE_TYPE}
      src={brand.thumbnail_url}
      cover={false}
    />
  </div>
);
